import React, { useEffect, useState } from "react";
import {
  amountFormatter,
  getAllBids_AuctionFloor,
  getAllWrongBids_AuctionFloor,
  getAuctionEventByUuid_AuctionFloor,
  getAuctionEventStatusById_AuctionFloor,
  getBidderByUserUuidAndEventUuid_AuctionFloor,
  getLatestBid_AuctionFloor,
  getLatestBidOfUser_AuctionFloor,
  useCountdownV2,
} from "services";
import { DateTime } from "luxon";
import Pusher from "pusher-js";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

import useInternetSpeed from "../../../../../app/hoc/useInternetSpeed";
import AuctionLoader from "./AuctionLoader";
import { Button } from "../../../../shadcn/components/ui/button";
import RefreshIcon from "../../../../icons/RefreshIcon";
import MapPin from "../../../../icons/MapPin";
import { Progress } from "../../../../shadcn/components/ui/progress";
import EventContentData from "./components/EventContentData";
import PropertyContentData from "./components/PropertyContentData";
import BidHistorySection from "./components/BidHistorySection";
import BidHistoryModel from "./components/BidHistoryModel";
import AuctionEndedModel from "./components/AuctionEndedModel";
import BidNotificationPanel from "./components/BidNotificationPanel";
import PlaceBidButtonSection from "./components/PlaceBidButtonSection";
import BidderTagCard from "./components/BidderTagCard";
import CancelledEventModel from "../auctionEvents/CancelledEventModel";
import AnnouncementEventModal from "./AnnouncementEventModal";
import AnnouncementEventModalV2 from "./AnnouncementEventModalV2";
import Dot from "../../../../icons/Dot";
import ViewOnlyAccessCard from "./components/ViewOnlyAccessCard";
import AuctionDisclaimerTag from "./components/AuctionDisclaimerTag";
import AuctionStartingSoonCard from "./components/AuctionStartingSoonCard";
import AuctionNetworkMonitorBanner from "./components/AuctionNetworkMonitorBanner";
interface AuctionFloorV2Props {
  eventData: any;
  bidderName: any;
}

export default function AuctionFloorV2({
  eventData,
  bidderName,
}: AuctionFloorV2Props) {
  const [reservePrice, setReservePrice] = useState(0);
  const [amount, setAmount] = useState<any>(0);
  const [biddingAmount, setBiddingAmount] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [status, setStatus] = useState("");
  const [currentTime, setCurrentTime] = useState<any>(0);
  const [bidsEvent, setBidsEvent] = useState<any[]>([]);
  const [latestBid, setLatestBid] = useState<any>(null);
  const [prevBid, setPrevBid] = useState<any>(null);
  const [currentUserLatestBid, setCurrentUserLatestBid] = useState<any>(null);
  const [wrongBidsEvent, setWrongBidsEvent] = useState<any[]>([]);
  const [showSuccessNotification, setShowSuccessNotification] =
    useState<Boolean>(false);
  const [showFailedNotification, setShowFailedNotification] =
    useState<Boolean>(false);
  const [failedNotification, setFailedNotification] = useState<any>(null);
  const [loading, setLoading] = useState<any>(true);
  const [biddingType, setBiddingType] = useState<any>("ib");
  const [connectionStatus, setConnectionStatus] = useState<any>("Offline");
  const [flag, setFlag] = useState<Boolean>(false);
  const [serverTime, setServerTime] = useState(0);
  const [timeOffset, setTimeOffset] = useState(0);
  const [showAuctionEndedModel, setShowAuctionEndedModel] = useState(false);
  const [announcementModals, setAnnouncementModals] = useState<any[]>([]);
  const [biddingAccessType, setBiddingAccessType] = useState<any>("");
  const [isHighestBidder, setIsHighestBidder] = useState<any>(false);

  const [showBidHistoryModel, setShowBidHistoryModel] =
    useState<boolean>(false);
  const [openCancelledEventModal, setOpenCancelledEventModal] =
    useState<any>(false);
  const [openAnnouncementEventModal, setOpenAnnouncementEventModal] =
    useState<any>(false);

  const handleBidsResult = async () => {
    // openModal("Auction has ended!", "", "bg-green-50 text-green-500");
    setShowAuctionEndedModel(true);
  };

  const filterSwissInitialBids = (bids: any[]) => {
    const initialBids = bids.filter((bid) => bid?.meta?.initial_bid === true);
    const nonInitialBids = bids.filter(
      (bid) => bid?.meta?.initial_bid !== true,
    );
    if (!initialBids.length) return bids;
    const lastInitialBid = initialBids[initialBids.length - 1];
    return [...nonInitialBids, lastInitialBid];
  };

  const checkBidStatus = async (checkStatus = 0) => {
    console.log("isTimeEnded inside checkBidStatus", isTimeEnded, checkStatus);
    if (isTimeEnded || checkStatus) {
      try {
        setFlag(true);
        setTimeout(async () => {
          const res: any = await getAuctionEventStatusById_AuctionFloor(id);
          if (res?.status && res?.status === "end") {
            console.log("status came as end", res?.status);
            setStatus(res?.status);
            handleBidsResult();
          }
        }, 1000);
        setFlag(false);
      } catch (error) {
        setFlag(false);
        console.log("error", error);
      }
    }
  };

  const {
    query: { id },
  } = useRouter();

  const router = useRouter();
  const { isOnline, isOnlineEventTriggered } = useInternetSpeed();
  const accessToken = useSelector((state: any) => state.bidderAuth.accessToken);
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });

  useEffect(() => {
    (async () => {
      if (user) {
        const data: any = await getBidderByUserUuidAndEventUuid_AuctionFloor(
          user.uuid,
          id,
          "verified",
        );
        if (data.length === 0) {
          router.push("/auction-events");
        } else if (data.length > 0) {
          setBiddingAccessType(data[0]?.access_type?.toLowerCase() || "");
        }
      }
    })();
  }, [user, id]);

  // fetch bids data
  const init = async (uuid: any) => {
    setLoading(true);
    try {
      const data: any = await getAuctionEventByUuid_AuctionFloor(uuid);
      if (data) {
        setServerTime(data.server_time);
        const isSwissAuction = data.event_type === "Asset transfer";
        const allBid: any = await getAllBids_AuctionFloor(data.uuid);
        const allWrongBids: any = await getAllWrongBids_AuctionFloor(
          data.uuid,
          user.uuid,
        );
        const currentUserLastBid: any = await getLatestBidOfUser_AuctionFloor(
          data.uuid,
          user.uuid,
        );

        setCurrentUserLatestBid(currentUserLastBid);
        if (allBid) {
          const filteredBids = isSwissAuction
            ? filterSwissInitialBids(allBid)
            : allBid;
          setBidsEvent(filteredBids);
          if (filteredBids.length >= 2) {
            setPrevBid(filteredBids[filteredBids.length - 2]);
          }
        }
        if (allWrongBids) {
          setWrongBidsEvent(allWrongBids);
        }
        const lastBid: any = await getLatestBid_AuctionFloor(data.uuid);
        setLatestBid(lastBid);
        setReservePrice(data.reserve_price);
        setStatus(data.status);
        const start_timestamp = DateTime.fromISO(data.start_date_time)
          .setZone("Asia/Kolkata")
          .toMillis();
        setStartTime(start_timestamp);

        if (lastBid) {
          setAmount(lastBid.final_amount);
          setBiddingAmount(lastBid.final_amount);
          setEndTime(parseInt(lastBid.final_end_time));
        } else {
          setAmount(parseInt(data.reserve_price));
          setBiddingAmount(parseInt(data.reserve_price));
          setEndTime(parseInt(data.final_end_date));
        }
        setBiddingType(data.bidding_type);
        setLoading(false);
      }
    } catch (err) {
      console.log("error in init::>", err);
      // setLoading(false);
      router.reload();
    }
  };

  // pusher functionality
  useEffect(() => {
    // Don't establish Pusher connection until we have all required data
    if (!eventData || !user?.uuid || !accessToken || !bidderName) {
      return;
    }

    // Pusher.logToConsole = false;
    let authConfig = {};
    let channelId = `auction-event-${id}`;

    if (process.env.NEXT_PUBLIC_ENABLE_BIDDER_ACTIVITY === "true") {
      authConfig = {
        authEndpoint: `${process.env.NEXT_PUBLIC_API_URL}/auction-floor/pusher/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            event_uuid: id,
            user_type: "bidder",
            user_name: bidderName,
          },
        },
      };
      channelId = `presence-${channelId}`;
    }

    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
      ...authConfig,
    });

    console.log("channelId: ", channelId);
    const channel = pusher.subscribe(channelId);

    channel.bind("bidding_value_has_been_changed", (data: any) => {
      handleDataChange(data);
      setBidsEvent((prev) => [...prev, data]);
      setShowAuctionEndedModel(false);
      // setBidsEvent([...bidsEvent, data]);
    });

    channel.bind("user_placed_wrong_bid", (data: any) => {
      if (data.user_uuid === user.uuid) {
        setServerTime(data.server_time);
        setWrongBidsEvent((prev) => [...prev, data]);
        setFailedNotification(null);
        setShowFailedNotification(false);
        setShowSuccessNotification(false);
        setFailedNotification(data.reason);
        setShowFailedNotification(true);
        setShowAuctionEndedModel(false);
        (async () => {
          await checkBidStatus();
        })();
      }
    });

    channel.bind("auction_event_has_started", (data: any) => {
      if (data) {
        setServerTime(data.server_time);
        setStatus("live");
        setShowAuctionEndedModel(false);
      }
    });

    channel.bind("auction_event_has_ended", (data: any) => {
      console.log("auction_event_has_ended----", data);

      if (data) {
        setAnnouncementModals([]);
        setStatus("end");
        handleBidsResult();
      }
    });
    // test it
    channel.bind("auction_event_has_cancelled", (data: any) => {
      console.log("auction_event_has_cancelled----", data);

      if (data) {
        setStatus("end");
        setShowBidHistoryModel(false);
        // setOpenAnnouncementEventModal(false);
        setAnnouncementModals([]);
        setOpenCancelledEventModal(data);
      }
    });

    channel.bind("auction_event_has_announcement", (data: any) => {
      console.log("auction_event_has_announcement----", data);

      // Old Announcement Logic
      //  if (data) {
      //    setOpenAnnouncementEventModal(data);
      //  }

      // New Logic
      if (data) {
        if (data.type === "announcement") {
          setAnnouncementModals((prev) => [
            ...prev,
            { data: data, openModal: true },
          ]);
        }
      }
    });

    pusher.connection.bind("error", function (err: any) {
      console.log("PUSHER ERROR:::>", err);
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        console.log(">>> CLOSED ABNORMALLY");
        // Websocket: CLOSED ABNORMALLY
        // get the data and refresh the page if fails
        init(id);
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
      setConnectionStatus("Offline");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
      setConnectionStatus("Online");
    });

    pusher.connection.bind("state_change", (states: any) => {
      const { current, previous } = states;
      console.log(`current state: ${current}, previous state: ${previous}`);
      switch (current) {
        case "failed":
          setConnectionStatus("Offline");
          break;
        case "disconnected":
          setConnectionStatus("Offline");
          break;
        case "unavailable":
          setConnectionStatus("Offline");
          break;
        case "connected":
          setConnectionStatus("Online");
          break;
        case "connecting":
          setConnectionStatus("Connecting"); // Connecting
          break;
        default:
          break;
      }
    });

    return function cleanup() {
      pusher.disconnect();
    };
  }, [id, eventData, user?.uuid, accessToken, bidderName]);

  // if auction is ongoing and somebody came in between then fetch data from latest bid
  useEffect(() => {
    if (eventData) {
      init(eventData.uuid);
    }
  }, [eventData]);

  // get the timeoffset
  useEffect(() => {
    if (serverTime) {
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      setTimeOffset(offset);
    }
  }, [serverTime]);

  // current time
  useEffect(() => {
    console.log("Update time");
    const intervalId = setInterval(() => {
      setCurrentTime(
        DateTime.now()
          .plus({ milliseconds: timeOffset })
          .setZone("Asia/Kolkata")
          .toFormat("DDD hh:mm:ss a"),
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeOffset]);

  useEffect(() => {
    console.log("isOnline::>", isOnline);
    if (!isOnline) {
      setConnectionStatus("Offline");
    } else {
      setConnectionStatus("Online");
    }
  }, [isOnline]);

  useEffect(() => {
    if (isOnlineEventTriggered) {
      router.reload();
    }
  }, [isOnlineEventTriggered]);

  const handleDataChange = async (data: any) => {
    // send the server time from the lambda as well
    console.log("data.server_time::::>", data.server_time);
    setServerTime(data.server_time);
    setAmount(data.final_amount);
    setEndTime(data.final_end_time);
    if (latestBid) {
      setPrevBid(latestBid);
    }
    const lastBid: any = await getLatestBid_AuctionFloor(data.event_uuid);

    setLatestBid((prev: any) => {
      setPrevBid(prev);
      return lastBid;
    });

    const currentUserLastBid: any = await getLatestBidOfUser_AuctionFloor(
      data.event_uuid,
      user.uuid,
    );
    setCurrentUserLatestBid(currentUserLastBid);
    if (user.uuid === data.user_uuid) {
      setFailedNotification(null);
      setShowFailedNotification(false);
      setShowSuccessNotification(true);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowSuccessNotification(false);
      setFailedNotification(null);
      setShowFailedNotification(false);
    }, 5000);
  }, [showSuccessNotification, showFailedNotification]);

  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    endTime,
    timeOffset,
  );

  useEffect(() => {
    console.log("isTimeEnded::>", isTimeEnded);
    (async () => {
      await checkBidStatus(isTimeEnded);
    })();
  }, [isTimeEnded]);

  const isNetworkSpeedDetectionEnabled =
    process.env.NEXT_PUBLIC_ENABLE_INTERNET_SPEED_MONITORING === "true";

  return (
    <div>
      {loading ? (
        <AuctionLoader />
      ) : (
        <div>
          <div className="w-full mb-2">
            <AuctionStartingSoonCard eventData={eventData} status={status} />
            <AuctionDisclaimerTag />
            {isNetworkSpeedDetectionEnabled && <AuctionNetworkMonitorBanner />}
          </div>
          <div className="flex flex-col lg:flex-row gap-2 lg:gap-5">
            <div className="w-full bg-white relative px-3 lg:px-6 py-5">
              <div className="absolute right-4 top-3 lg:top-3">
                <Button className="h-[30px] bg-white hover:bg-white text-brand-orange hover:border-brand-orange text-xs font-semibold">
                  <div
                    className="flex gap-1 items-center"
                    onClick={() => router.reload()}
                  >
                    <RefreshIcon />
                    <div>Refresh</div>
                  </div>
                </Button>
              </div>

              {["Connecting", "Offline"].includes(connectionStatus) && (
                <div className="fixed left-1/2 -translate-x-1/2 top-5 z-10">
                  <BidNotificationPanel notificationType="unstableNet" />
                </div>
              )}
              {showSuccessNotification && (
                <div className="absolute right-0 top-2 z-10">
                  <BidNotificationPanel notificationType="bidSuccess" />
                </div>
              )}
              {showFailedNotification && (
                <div className="absolute right-0 top-2 z-10">
                  <BidNotificationPanel
                    notificationType="bidFailure"
                    reason={failedNotification}
                  />
                </div>
              )}

              <div className="flex flex-col gap-3 mid:gap-4">
                <div className="grid grid-cols-1 mid:grid-cols-3 items-end xl:items-start">
                  <div className="mid:col-span-2">
                    <div>
                      <h3 className="text-brand-textBlack font-sans text-sm lg:text-base font-semibold capitalize">
                        {`${eventData?.property_dump.asset?.name} - ${eventData?.property_dump?.sub_asset_type?.name} `}
                      </h3>
                      <div className="flex items-start mt-1">
                        <MapPin className="mr-1 w-3 h-3" />
                        <span className="text-[10px] lg:text-xs text-brand-textGrey capitalize">
                          {`${eventData?.property_dump?.city?.name}, ${eventData?.property_dump?.state?.name}`}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="justify-self-end lg:justify-self-start flex">
                    <div className="bg-white py-1 px-3 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
                      <Dot />
                      <span className="text-[10px] font-sans pl-3 font-normal text-brand-textBlack tracking-widest">
                        ID {eventData?.listing_id}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <div className="">
                    <div className="text-sm font-sans text-brand-textBlack leading-4 mid:leading-7">
                      Latest Bidding Price{" "}
                    </div>
                    <p className="max-w-2xl text-sm text-brand-textGrey flex flex-col mid:flex-row mid:items-end gap-0 mid:gap-2">
                      <span className="text-lg xl:text-[25px] font-bold text-brand-orange">
                        {latestBid ? `₹ ${amountFormatter(amount)}` : "NA"}
                      </span>
                      <span className="text-xs sm:text-sm">
                        at{" "}
                        {status !== "end"
                          ? `${currentTime} (IST)`
                          : latestBid?.frontend_timestamp &&
                            `${DateTime.fromMillis(
                              typeof endTime === "string"
                                ? parseInt(endTime)
                                : endTime,
                            )
                              .setZone("Asia/Kolkata")
                              .toFormat("DD hh:mm:ss a")} (IST)`}
                      </span>
                    </p>
                  </div>
                  <div>
                    {connectionStatus !== "Offline" && (
                      <div className="flex flex-col">
                        {status === "live" && (
                          <div className="flex justify-end pb-2">
                            <span className="inline-flex w-16 items-center rounded-sm bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                              <svg
                                className="-ml-0.5 mr-1.5 h-2 w-2 text-green-400"
                                fill="currentColor"
                                viewBox="0 0 8 8"
                              >
                                <circle cx={4} cy={4} r={3} />
                              </svg>
                              Live
                            </span>
                          </div>
                        )}
                        <div className="w-[124px] lg:w-[135px]">
                          <ProgressBar
                            currentTime={currentTime}
                            startTime={startTime}
                            endTime={endTime}
                          />
                          <div className="flex items-center justify-between gap-2 mt-1 lg:mt-2">
                            <div className="w-[60px] text-xs lg:text-sm">
                              Time left
                            </div>
                            <div
                              className={
                                "text-sm sm:col-span-2 " +
                                `${
                                  status === "live" &&
                                  endTime &&
                                  endTime -
                                    DateTime.now()
                                      .setZone("Asia/Kolkata")
                                      .toMillis() >
                                    parseInt(eventData?.extend_time_at) *
                                      60 *
                                      1000
                                    ? "text-[#4DBB3E] font-medium"
                                    : "text-red-600 font-semibold"
                                }`
                              }
                            >
                              {flag ? (
                                <div>loading...</div>
                              ) : (
                                <>
                                  {status === "live"
                                    ? hours < 10
                                      ? hours > 0
                                        ? `0${hours}`
                                        : "00"
                                      : hours
                                    : "00"}
                                  :
                                  {status === "live"
                                    ? minutes < 10
                                      ? minutes > 0
                                        ? `0${minutes}`
                                        : "00"
                                      : minutes
                                    : "00"}
                                  :
                                  {status === "live"
                                    ? seconds < 10
                                      ? seconds > 0
                                        ? `0${seconds}`
                                        : "00"
                                      : seconds
                                    : "00"}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <BidderTagCard
                  latestBid={latestBid}
                  bidsEvent={bidsEvent}
                  currentUserLatestBid={currentUserLatestBid}
                  setIsHighestBidder={setIsHighestBidder}
                />
                <BidHistorySection
                  bidsEvent={bidsEvent}
                  wrongBidsEvent={wrongBidsEvent}
                  setShowBidHistoryModel={setShowBidHistoryModel}
                  isSwissAuction={eventData?.event_type === "Asset transfer"}
                />
                {biddingAccessType === "primary" ? (
                  <PlaceBidButtonSection
                    eventData={eventData}
                    amount={amount}
                    id={id}
                    status={status}
                    reservePrice={reservePrice}
                    latestBid={latestBid}
                    biddingType={biddingType}
                    connectionStatus={connectionStatus}
                    isTimeEnded={isTimeEnded}
                    isHighestBidder={isHighestBidder}
                    // biddingIncrementAmount={eventData?.bidding_increment_amount}
                  />
                ) : (
                  <ViewOnlyAccessCard />
                )}
              </div>
              <BidHistoryModel
                bidsEvent={bidsEvent}
                wrongBidsEvent={wrongBidsEvent}
                open={showBidHistoryModel}
                setOpen={setShowBidHistoryModel}
                isSwissAuction={eventData?.event_type === "Asset transfer"}
              />
              <AuctionEndedModel
                open={showAuctionEndedModel}
                setOpen={setShowAuctionEndedModel}
              />

              <CancelledEventModel
                openCancelledEventModal={openCancelledEventModal}
                setOpenCancelledEventModal={setOpenCancelledEventModal}
              />

              {/* Old Announcement Modal */}
              {/* <AnnouncementEventModal
              key={announcementModalKey}
              openAnnouncementEventModal={openAnnouncementEventModal}
              setOpenAnnouncementEventModal={setOpenAnnouncementEventModal}
            /> */}

              {announcementModals.map((modal, index) => (
                <AnnouncementEventModalV2
                  index={index} // Ensure unique key
                  setAnnouncementModals={setAnnouncementModals} // Always open if it's in the array
                  data={announcementModals} // Pass the announcement data
                />
              ))}
            </div>
            <div className=" min-w-[280px] bg-brand-lightOrange">
              <EventContentData
                data={eventData}
                biddingType={biddingType}
                latestBidAmount={amount}
                currentUserLatestBid={currentUserLatestBid}
                latestBid={latestBid}
                status={status}
                endTime={endTime}
              />
              <PropertyContentData
                bank={eventData?.property_dump?.bank?.name}
                state={eventData?.property_dump?.state?.name}
                city={eventData?.property_dump?.city?.name}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

interface ProgressProps {
  startTime: number;
  endTime: number;
  currentTime: any;
}

const ProgressBar: React.FC<ProgressProps> = ({
  startTime,
  endTime,
  currentTime,
}) => {
  const calculateProgress = (): number => {
    const serverTime = DateTime.fromFormat(
      String(currentTime),
      "d MMMM yyyy hh:mm:ss a",
      {
        zone: "Asia/Kolkata",
      },
    ).toMillis();
    if (startTime >= serverTime) return 0;
    if (serverTime >= endTime) return 100;

    const elapsed = serverTime - startTime;
    const totalDuration = endTime - startTime;
    return Math.min((elapsed / totalDuration) * 100, 100);
  };

  return (
    <div className="w-full ">
      <Progress
        value={calculateProgress()}
        className="h-[3px] w-full"
        fillColor="bg-[#5D5FEF]"
      />
    </div>
  );
};
